import { io, Socket } from "socket.io-client";
import Config from "../globals/Config";

const SOCKET_URL = `${Config.host}:${Config.port}`;

// Initialize the socket instance
export const socket: Socket = io(SOCKET_URL, {
	autoConnect: false, // We manually connect after login
	withCredentials: true,
	transports: ["websocket"], // Forces websocket to avoid polling issues
});

// Helper to manage connection
export const connectSocket = (userId: string) => {
	if (!socket.connected) {
		socket.connect();
		socket.emit("join_room", userId);
		console.log(`Socket connecting for user: ${userId}`);
	}
};

export const disconnectSocket = () => {
	if (socket.connected) {
		socket.disconnect();
	}
};
